import React from 'react'
import { Collapse, Button, Label, Media } from 'reactstrap'
import { UsersApi } from 'typescript-axios'
import ReactHtmlParser from 'react-html-parser'
import Slider from '@mui/material/Slider'
import useTranslation from '../hooks/UseTranslation'

import { getAxiosParams } from '../utils/client'
import { UserContext } from '../contexts/UserContext'

const USERS_SERVICE = new UsersApi(getAxiosParams())

const GuruReferral = (props) => {
  const { t } = useTranslation()
  const { loggedUser, setLoggedUser } = React.useContext(UserContext)

  if (!loggedUser) return ''

  let { has_referral_enabled, n_ref_threshold, referrals_free_classes, referrals_free_classes_referee } =
    loggedUser
  has_referral_enabled = !!has_referral_enabled
  const [referral, setReferral] = React.useState({
    n_ref_threshold,
    referrals_free_classes_referee: referrals_free_classes_referee || 0,
    referrals_free_classes: referrals_free_classes || 1
  })

  const [isEdit, setIsEdit] = React.useState(false)

  const onEditClick = () => setIsEdit((e) => !e)

  React.useEffect(() => {
    setReferral({
      n_ref_threshold: loggedUser.n_ref_threshold,
      referrals_free_classes: loggedUser.referrals_free_classes || 1,
      referrals_free_classes_referee: loggedUser.referrals_free_classes_referee || 0
    })
  }, [loggedUser])

  React.useEffect(() => {
    if (!isEdit) {
      USERS_SERVICE.updateUserMeApiV1UsersMePut(referral).then((res) =>
        setLoggedUser(res.data)
      )
    }
  }, [isEdit])

  return (
    <div className='text-block'>
      <div className='d-flex justify-content-between'>
        <h5 className='text-first-letter mb-4'>{t('guru_referral')}</h5>
      </div>
      <Media className='text-muted mb-4'>
        <Media body className='mt-n1'>
          <div
            dangerouslySetInnerHTML={{ __html: t('guru_referral_content') }}
          />
        </Media>
      </Media>
      <div className='text-muted'>
        <div className='mb-2'>
          {has_referral_enabled
            ? ReactHtmlParser(
              t(
                'guru_referral_enabled',
                n_ref_threshold,
                referrals_free_classes
              )
            )
            : t('guru_referral_disabled')}
        </div>
        <div className='text-right'>
          <Button color='link' className='mb-3 p-0' onClick={onEditClick}>
            {t(isEdit ? 'save' : 'update')}
          </Button>
        </div>
        <Collapse isOpen={!!isEdit} className='px-4'>
          <div className='pt-2'>
            <div className='d-flex justify-content-between'>
              <Label className='form-label' for='postal_code'>
                {t('guru_referral_n_ref_threshold')}
              </Label>
              <div className='font-weight-bold text-right'>
                {!!referral.n_ref_threshold && referral.n_ref_threshold > 0
                  ? t(
                    'guru_referral_n_ref_threshold_{}',
                    referral.n_ref_threshold
                  )
                  : t('disabled')}
              </div>
            </div>
            <Slider
              color='primary'
              disabled={!isEdit}
              aria-label='Referral program'
              // getAriaValueText={valuetext}
              valueLabelDisplay='off'
              step={1}
              onChange={(e, newVal) =>
                setReferral(
                  (r) => ({
                    ...r,
                    n_ref_threshold: newVal > 0 ? newVal : null
                  }),
                  false
                )
              }
              value={referral.n_ref_threshold}
              min={0}
              max={5}
            />
            <div className='d-flex justify-content-between'>
              <Label className='form-label' for='postal_code'>
                {t('guru_referral_n_classes_free')}
              </Label>
              <div className='font-weight-bold text-right'>
                {t('packs_n_classes', referral.referrals_free_classes)}
              </div>
            </div>
            <Slider
              color='primary'
              disabled={!isEdit}
              aria-label='Referral program'
              // getAriaValueText={valuetext}
              valueLabelDisplay='off'
              step={1}
              onChange={(e, newVal) =>
                setReferral(
                  (r) => ({
                    ...r,
                    referrals_free_classes: newVal > 0 ? newVal : null
                  }),
                  false
                )
              }
              value={referral.referrals_free_classes}
              min={1}
              max={10}
            />
            <div className='d-flex justify-content-between'>
              <Label className='form-label' for='postal_code'>
                {t('guru_referral_n_classes_free_for_referee')}
              </Label>
              <div className='font-weight-bold text-right'>
                {t('packs_n_classes', referral.referrals_free_classes_referee)}
              </div>
            </div>
            <Slider
              color='primary'
              disabled={!isEdit}
              aria-label='Referral program'
              // getAriaValueText={valuetext}
              valueLabelDisplay='off'
              step={1}
              onChange={(e, newVal) =>
                setReferral(
                  (r) => ({
                    ...r,
                    referrals_free_classes_referee: newVal > 0 ? newVal : null
                  }),
                  false
                )
              }
              value={referral.referrals_free_classes_referee}
              min={1}
              max={10}
            />
            <Media className='text-muted mb-4'>
              {ReactHtmlParser(t('guru_referral_inside_collapse'))}
            </Media>
            <Media className='text-muted mb-4'>
              <Media body className='mt-n1'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('guru_referral_disclaimer')
                  }}
                />
              </Media>
            </Media>
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default GuruReferral
